// src/app/_services/refill-request.service.ts

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class RefillRequestService {
  private apiUrl = `${environment.apiUrl}/refill-requests`;

  constructor(private http: HttpClient) { }

  createRefillRequest(request: {
    userId: string,
    packingId: string,
    quantityRequested: number
  }): Observable<any> {
    return this.http.post(`${this.apiUrl}/create`, request);
  }

  getRefillRequests(page: number = 1, limit: number = 10, search: string = '', sortBy: string = 'created_at', sortOrder: string = 'desc'): Observable<any> {
    let params = new HttpParams()
        .set('page', page.toString())
        .set('limit', limit.toString())
        .set('sortBy', sortBy)
        .set('sortOrder', sortOrder);

    if (search) {
        params = params.set('search', search);
    }

    return this.http.get(`${this.apiUrl}/refill-requests`, { params });
}



  approveRefillRequest(requestId: string, adminNotes: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/approve/${requestId}`, { adminNotes });
  }

  rejectRefillRequest(requestId: string, adminNotes: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/reject/${requestId}`, { adminNotes });
  }
}